<template>
    <div class="header_top_box">
        <div class="container">
            <!-- 右侧个人模块 -->
            <ul class="header_top_rt">
                <!-- 登录注册 -->
                <li v-if="!isLogin">
                    <router-link to="/login" 
                        class="header_top_rt_login">
                        {{$t('message.header.login')}}
                    </router-link>
                    <router-link to="/register" 
                        class="header_top_rt_login">
                        {{$t('message.header.register')}}
                    </router-link>
                </li>
                <!-- 个人中心注销 -->
                <li v-else>
                    <router-link to="/center" 
                        class="header_top_rt_login">
                        {{$t('message.header.center')}}
                    </router-link>
                    <a href="javascript:;"
                        class="header_top_rt_login"
                        @click="signOut">
                        {{$t('message.header.signout')}}
                    </a>
                </li>
                <!-- 多语言组件 -->
                <!-- <li>
                    <lang-select></lang-select>
                </li> -->
                <!-- 报价车 & 购物车 -->
                <li>
                    <!-- 报价车 -->
                    <header-dropdown
						v-if="power.includes(0) || power.includes(18) || power.includes(111)"
                        router-link="/center/quoteCart"
                        :list-data="quote_cart"
                        :handleDel="delQuoteCart"
                        :handleNum="quoteCartNum"
                        :handleJump="() => $router.push('/center/quoteCart')">
                        <!-- 标题 -->
                        <template #title>
                            <i class="glyphicon glyphicon-shopping-cart"></i>
                            <span>&nbsp;{{$t('message.header.quoteCart')}}</span>
                        </template>
                        <!-- 未登录 -->
                        <template #goLogin>
                            <span>{{$t('message.header.goLogin1')}}</span>
                            <router-link to="/login">{{$t('message.header.goLogin2')}}</router-link>
                        </template>
                        <!-- 无参数 -->
                        <template #nothing>
                            <span>{{$t('message.header.nothing')}}</span>
                        </template>
                        <!-- 按钮 -->
                        <template #total_btn >
                            <span>{{$t('message.header.goQuoteCart')}}</span>
                        </template>
                    </header-dropdown>
                    <!-- 购物车 -->
                    <header-dropdown
					    v-if="power.includes(0) || power.includes(20) || power.includes(111)"
                        router-link="/center/cart"
                        :list-data="cart"
                        :handleDel="delCart"
                        :handleNum="cartNum"
                        :handleJump="() => $router.push('/center/cart')">
                        <!-- 标题 -->
                        <template #title>
                            <i class="glyphicon glyphicon-shopping-cart"></i>
                            <span>&nbsp;{{$t('message.header.shoppingCart')}}</span>
                        </template>
                        <!-- 未登录 -->
                        <template #goLogin>
                            <span>{{$t('message.header.goLogin1')}}</span>
                            <router-link to="/login">{{$t('message.header.goLogin2')}}</router-link>
                        </template>
                        <!-- 无参数 -->
                        <template #nothing>
                            <span>{{$t('message.header.nothing')}}</span>
                        </template>
                        <!-- 按钮 -->
                        <template #total_btn>
                            <span>{{$t('message.header.goShoppingCart')}}</span>
                        </template>
                    </header-dropdown>
                </li>
            </ul>
            <!-- 左侧栏目模块 -->
            <ul class="header_top_lf">
                <router-link to="/" tag="li">{{$t('message.header.main')}}</router-link>
                <router-link to="/about" tag="li">{{$t('message.header.about')}}</router-link>
                <router-link to="/culture" tag="li">{{$t('message.header.culture')}}</router-link>
                <router-link to="/news" tag="li">{{$t('message.header.news')}}</router-link>
                <router-link to="/contact" tag="li">{{$t('message.header.contact')}}</router-link>
                <router-link to="/service" tag="li">{{$t('message.header.service')}}</router-link>
                <router-link to="/partner" tag="li">{{$t('message.header.partner')}}</router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
        }
    },
    computed: mapState({
        isLogin: state => state.user.islogin,
		power: state => state.user.power,
        cart: state => state.order.cart,
        quote_cart: state => state.order.quote_cart
    }),
    components: {
        langSelect: () => import('@/components/LangSelect'),
        headerDropdown: () => import('@/components/headerDropdown')
    },
	
    methods: {
        ...mapActions([
            "sendSignOut",
            "getCart",
            "handleCartNum", // 购物车数量更改
            "handleCartDel", // 购物车删除
            "getQuoteCart",
            "handleQuoteCartNum", // 报价车数量更改
            "handleQuoteCartDel" // 报价车删除
        ]),
        signOut(){ // 注销按钮
            this.$confirm(this.$t("message.header.confirmMsg"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning',
                center: false
            }).then(()=>{
               this.sendSignOut().then((res) => {
                   localStorage.setItem('signOut', "");
                   localStorage.removeItem('signOut');
                   if(res){
                       this.$message({
                           type: "success",
                           message: this.$t("message.header.signoutSucc"),
                           showClose: true,
                       })
                       setTimeout(() => {
                           this.$router.go(0)
                       },1000)
                   }
               })
            }).catch(()=>{})
        },
        cartNum(goods_number, goods){ // 购物车数量更改
            let { rec_id, goods_attr_id } = goods;
            this.handleCartNum({
                rec_id,
                goods_attr_id,
                goods_number
            }).then(res => {
                if(res.type === false){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cart.errmsg5"),
                        type: "error"
                    })
                }
            }).catch(() => {})
        },
        delCart(goods){ // 删除购物车商品
            let { rec_id } = goods;
            this.handleCartDel(rec_id).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.header.delSucc"),
                        type: 'success'
                    })
                }
            })
        },
        quoteCartNum(goods_number, goods){ // 报价车数量更改
            let { quo_id, goods_attr_id, goods_specification_id } = goods;
            this.handleQuoteCartNum({
                quo_id,
                goods_attr_id,
                goods_number,
                goods_specification_id
            })
        },
        delQuoteCart(goods){ // 报价车删除
            let { quo_id } = goods;
            this.handleQuoteCartDel([quo_id]).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.header.delSucc"),
                        type: 'success'
                    })
                }
            })
        }
    },
    mounted() {
        this.getCart();
        this.getQuoteCart();
    },
}
</script>

<style scoped>
/* 头部盒子 */
.header_top_box{
    height: 50px;
    background-color: #333;
}
.header_top_box>.container{
    height: 100%;
}

/* 栏目导航 */
.header_top_lf{
    height: 100%;
    overflow: hidden;
}
.header_top_lf>li{
    float: left;
    height: 100%;
    line-height: 50px;
    padding: 0 15px;
    color: #fff;
    cursor: pointer;
    transition: all .1s linear;
}
.header_top_lf>li:hover,
.header_top_lf>li.active{
    background: #fff;
    color: #333;
}

/* 个人模块 */
.header_top_rt{
    height: 100%;
    float: right;
}
.header_top_rt>li{
    float: left;
    height: 100%;
    margin-left: 10px;
    line-height: 50px;
}
/* 用户操作部分 */
.header_top_rt_login{
    display: inline-block;
    padding: 0 20px;
    color: #fff;
}
.header_top_rt_login:hover{
    color: #FF6700
}
</style>
